export default class CalendarDate {
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {number} day
     */
    constructor (year, month, day) {
        this.year = year
        this.month = month
        this.day = day
    }

    static getCalendarYearBounds () {
        return [1900, 2070]
    }

    /**
     * @return {Date}
     */
    static now () {
        return new Date()
    }

    /**
     * @param {number|null} year
     * @param {number|null} month
     * @param {number|null} day
     * @returns {CalendarDate}
     */
    newInstance (year = null, month = null, day = null) {
        return new CalendarDate(year ?? this.year, month ?? this.month, day ?? this.day)
    }

    /**
     * @returns {number}
     */
    daysInMonth () {
        return new Date(this.year, this.month + 1, 0).getDate()
    }

    /**
     * @returns {CalendarDate}
     */
    nextMonth () {
        return this.newInstance(this.year + (this.month + 1 > 11 ? 1 : 0), this.month + 1 > 11 ? 0 : this.month + 1, 1)
    }

    /**
     * @returns {CalendarDate}
     */
    prevMonth () {
        return this.newInstance(this.year - (this.month - 1 < 0 ? 1 : 0), this.month - 1 < 0 ? 11 : this.month - 1, 1)
    }

    /**
     * @returns {CalendarDate}
     */
    startOfMonth () {
        return this.newInstance(this.year, this.month, 1)
    }

    /**
     * @returns {CalendarDate}
     */
    endOfMonth () {
        const date = new Date(this.year, this.month, 1)
        date.setMonth(date.getMonth() + 1)
        date.setDate(0)
        return this.newInstance(date.getFullYear(), date.getMonth(), date.getDate())
    }

    setYear (year) {
        return this.newInstance(year, this.month, this.day)
    }

    setMonth (month) {
        return this.newInstance(this.year, month, this.day)
    }

    getWeekDay () {
        return new Date(this.year, this.month, this.day).getDay()
    }

    setDay (day) {
        return this.newInstance(this.year, this.month, day)
    }

    /**
     * @returns Date
     */
    toDate () {
        return new Date(this.year, this.month, this.day)
    }

    get weekDay () {
        return this.getWeekDay()
    }
}
